module.exports = __webpack_public_path__ + "static/media/MaritimeLaw.03bbf56e.PNG";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/MaritimeLaw.PNG
// module id = 1771
// module chunks = 1